const translation = {
  es: {
    modal: {
      logout: "¿Estas seguro de cerrar la sesión?",
      unconfirmedChanges:
        "Asegurate de haber completado tus transacciones, los cambios no guardados se perderán.",
      cancel: "Cancelar",
      confirm: "Continuar",
    },
  },
  en: {
    modal: {
      logout: "¿Are you sure you want to sign out?",
      unconfirmedChanges:
        "Make sure you have completed your transactions, unsaved changes will be lost.",
      cancel: "Cancel",
      confirm: "Continue",
    },
  },
};
export default translation;
